import { Table, TableColumnsType } from "antd";
import _ from "lodash";
import { FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from 'react-i18next';
import exportTable from "../../../lib/exportTable";
import { IPBTSummary } from "../../../models/statistics.model";
import { RootState } from "../../../store/rootReducer";
import DownloadButton from "../../DownloadButton";
import moment from "moment";
import useUtil from "../../../hooks/useUtil";
import { ISemesterMonth } from "../../../models/semesters.model";

interface IProps {
  rawData: IPBTSummary[]|undefined;
  rawData2: ISemesterMonth[]|undefined;
}

const Summary: FC<IProps> = ({
  rawData,
  rawData2
}) => {
  const { t } = useTranslation();
  const { getCommonCodeLabel } = useUtil();
  const { campusData } = useSelector((state: RootState) => state.campusData);

  const [data, setData] = useState<IPBTSummary[]>([]);
  const [searchMonth, setSearchMonth] = useState<String[]>([]);

  useEffect(() => {
    if (rawData) {
      const newData: any = _.cloneDeep(rawData);

      newData.forEach((item: any) => {
        const campus = campusData.find(campus => campus.campusCode === item.campusCode);
        if (campus) {
          item.campusKorName = campus.campusKorName;
        } else {
          item.campusKorName = '';
        }

        item.eduStepCode = getCommonCodeLabel('PR0006', item.eduStepCode);
        item.avgFirst = (item.avgFirst === null) ? '-' : item.avgFirst;
        item.avgSecond = (item.avgSecond === null) ? '-' : item.avgSecond;
        item.avgThird = (item.avgThird === null) ? '-' : item.avgThird;
        item.totAvgScore = (item.totAvgScore === null) ? '-' : item.totAvgScore;
        item.completeRateFirst = (item.completeRateFirst === null) ? '-' : item.completeRateFirst + '%';
        item.completeRateSecond = (item.completeRateSecond === null) ? '-' : item.completeRateSecond + '%';
        item.completeRateThird = (item.completeRateThird === null) ? '-' : item.completeRateThird + '%';
        item.totAvgRate = (item.totAvgRate === null) ? '-' : item.totAvgRate + '%';
      });

      setData(newData);
    }
  }, [rawData]);

  const onExportTable = () => {
    //const _data: any = _.cloneDeep(data);
    const currentDate = moment(new Date());
    exportTable(columns, data, `PBT(${t('statistics.attendance.Tab1')})_(${currentDate.format('YYYYMMDD')})`, `${t('statistics.attendance.Tab1')}`, [15, 12, 10, 10, 10, 10, 10, 10, 10, 10, 12]);
  }

  useEffect(() => {
    const pbtSearchMonth : Array<string> = [];
    if(rawData2 !== undefined && rawData2.length === 3){
      pbtSearchMonth.push(rawData2[0].monthName + t('statistics.placementTest.1'));
      pbtSearchMonth.push(rawData2[1].monthName + t('statistics.placementTest.1'));
      pbtSearchMonth.push(rawData2[2].monthName + t('statistics.placementTest.1'));
    } else {
      pbtSearchMonth.push('-');
      pbtSearchMonth.push('-');
      pbtSearchMonth.push('-');
    }
    setSearchMonth(pbtSearchMonth);
  }, [rawData2]);

  const columns: TableColumnsType<IPBTSummary> = [
    {
      title: t('common.menu.campus'),
      dataIndex: 'campusKorName',
      key: 'campusKorName',
      align: 'center',
    },
    {
      title: t('common.label.1'),
      dataIndex: 'eduStepCode',
      align: 'center',
    },
    {
      title: t('statistics.dttt.column1'),
      dataIndex: 'courseName',
      key: 'courseName',
      align: 'center',
    },
    {
      title: t('statistics.dttt.column2'),
      children: [
        {
          title: searchMonth[0],
          dataIndex: 'avgFirst',
          key: 'avgFirst',
          align: 'center',
        },
        {
          title: searchMonth[1],
          dataIndex: 'avgSecond',
          key: 'avgSecond',
          align: 'center',
        },
        {
          title: searchMonth[2],
          dataIndex: 'avgThird',
          key: 'avgThird',
          align: 'center',          
        },
        {
          title: t('statistics.studentEnrollMonth.column9'),
          dataIndex: 'totAvgScore',
          align: 'center',
        }
      ]
    },
    {
      title: t('statistics.homework.column3') + '(%)',
      children: [
        {
          title: searchMonth[0],
          dataIndex: 'completeRateFirst',
          key: 'completeRateFirst',
          align: 'center',
        },
        {
          title: searchMonth[1],
          dataIndex: 'completeRateSecond',
          key: 'completeRateSecond',
          align: 'center',
        },    
        {
          title: searchMonth[2],
          dataIndex: 'completeRateThird',
          key: 'completeRateThird',
          align: 'center',
        },    
        {
          title: t('statistics.studentEnrollMonth.column9'),
          dataIndex: 'totAvgRate',
          align: 'center',
        }
      ]
    }
  ];

  return (
    <>
      <div className="comm-table__area line-type">
        <Table
          columns={columns}
          dataSource={data}
          pagination={{
            current: 1,
            pageSize: 999999999,
          }}
          rowKey="courseName"
        />
      </div>
      <div className="comm-bx__between">
        <DownloadButton onClick={onExportTable} />
      </div>
    </>
  );
}

export default Summary;
